import { useState } from 'react'
import { UPDATE_DOG_APPLICATION_REFERRAL_NAME } from '@graphql'
import { useMutation } from '@apollo/client/react'
import { MutationResponse } from '../types'

export const useReferralName = (application) => {
  const [showReferralBox, setShowReferralBox] = useState(false)
  const [referralName, setReferralName] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [success, setSuccess] = useState(false)

  const [mutateReferralName, { loading }] = useMutation<
    MutationResponse<'updateDogApplicationReferralName'>
  >(UPDATE_DOG_APPLICATION_REFERRAL_NAME, {
    onCompleted: (data) => {
      if (data.updateDogApplicationReferralName.errorMessage) {
        setError(data.updateDogApplicationReferralName.errorMessage)
        setSuccess(false)
      } else {
        setSuccess(true)
        setMessage('Referral name updated successfully')
        setShowReferralBox(false)
        setError('')
      }
    },
    onError: (mutationError) => {
      setError(mutationError.message || 'Something went wrong')
      setSuccess(false)
    },
  })

  const updateReferralName = (name) => {
    setError('')
    setMessage('')
    mutateReferralName({
      variables: {
        dogApplication: {
          id: application?.id,
          referralName: name,
        },
      },
    })
  }

  return {
    showReferralBox,
    setShowReferralBox,
    referralName,
    setReferralName,
    updateReferralName,
    error,
    success,
    message,
    loading,
  }
}
